<div class="c-adventureQuestStart">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-adventureQuestStart__container">
    <div
      class="c-adventureQuestStart__background"
      theming
      themingGroup="adventurequest"
      themingAsset="start-background"
      [themingOverride]="event?.assets">
      <div class="c-adventureQuestStart__info">
        <div
          class="c-adventureQuestStart__icon"
          theming
          themingGroup="adventurequest"
          themingAsset="logo"
          [themingOverride]="event?.assets"></div>

        <div class="c-adventureQuestStart__text">
          <span class="text title">{{
            'home.live-ops.adventure-quest.modal-start.title' | translate | uppercase
          }}</span>
          <span class="text subtitle">
            {{ 'home.live-ops.adventure-quest.modal-start.subtitle' | translate | uppercase }}
          </span>
        </div>

        <div class="c-adventureQuestStart__timer">
          <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
          <slotcom-animated-timer
            [showInDays]="true"
            [endDate]="adventureQuestStartModalData.expirationDate"
            (expired)="closeModal()"></slotcom-animated-timer>
        </div>
      </div>

      <slotcom-button
        class="c-button--pink"
        (safeClick)="openMultiGameChallengesProgressive()"
        audioType="functionality">
        {{
          adventureQuestStartModalData.properties.buttonText[lang]
            ? adventureQuestStartModalData.properties.buttonText[lang]
            : ('home.buttons.go-for-them' | translate | uppercase)
        }}
      </slotcom-button>
    </div>
  </div>
</div>
